import { Component, OnInit } from '@angular/core';
import { DashboardClientScope, DASHBOARD_CLIENT_SCOPE_STORAGE_KEY } from 'src/app/models/DashboardMetrics';
import { PermissionService } from 'src/app/services/permissionservice.service';
import { DASHBOARD_METRIC_GROUPS, DASHBOARD_UNSCOPED_GROUPS } from './dashboard-metrics.component';
import { ENROLLMENT_DUPLICATES_ALERT_GROUPS } from './enrollment-duplicates-alert.component';

@Component({
  selector: 'vex-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  breadcrumbs = [{ label: 'Dashboard', link: '/home' }];
  canViewMetrics = false;
  canViewEnrollmentDuplicatesAlert = false;
  canViewAll = false;
  scope: DashboardClientScope = 'mine';

  constructor(private permissionService: PermissionService) {}

  ngOnInit(): void {
    this.canViewMetrics = this.permissionService.hasPermission(DASHBOARD_METRIC_GROUPS);
    this.canViewEnrollmentDuplicatesAlert = this.permissionService.hasPermission(ENROLLMENT_DUPLICATES_ALERT_GROUPS);
    this.canViewAll = this.permissionService.hasPermission(DASHBOARD_UNSCOPED_GROUPS);
    this.scope = this.restoreScope();
  }

  onScopeChange(scope: DashboardClientScope): void {
    if (scope === 'all' && !this.canViewAll) {
      return;
    }
    if (this.scope === scope) {
      return;
    }
    this.scope = scope;
    localStorage.setItem(DASHBOARD_CLIENT_SCOPE_STORAGE_KEY, scope);
  }

  private restoreScope(): DashboardClientScope {
    if (!this.canViewAll) {
      return 'mine';
    }
    const stored = localStorage.getItem(DASHBOARD_CLIENT_SCOPE_STORAGE_KEY);
    return stored === 'mine' || stored === 'all' ? stored : 'mine';
  }
}
